module.exports = __webpack_public_path__ + "static/media/send_message.594fc262.svg";